export const generateHtml = (props) => {
  const data = props;
  const colspan = data?.navbarImages?.length;
  const footerURL = data.footerURL;
  const navBar = Array.from({ length: data?.navbarImages?.length })
    .map(
      (e, i) =>
        `<td nowrap>
        <a href="${data.navbarURLs[i]}">
          <img
            style="display: block; vertical-align: bottom;"
            src="${data.navbarImages[i]}"
          />
        </a>
      </td>`
    )
    .join("");
  const offers = Array.from({ length: data.offers })
    .map(
      (e, i) => `<tr>
        <td colspan="${colspan}" key="${i}">
          <a
            href="${data.offerLinks[i]}"
            ><img
              src="${data.offerImages[i]}"
              style="display: block; vertical-align: bottom"
              alt=""
          /></a>
        </td>
      </tr>`
    )
    .join("");

  const handleFooterNav = () => {
    const footerNav = `<tr id="navBar">
    ${Array.from({ length: data.navItems })
      .map(
        (e, i) =>
          `<td nowrap>
          <a href="${data.footerNavInputValues[i]}">
            <img
              style="display: block; vertical-align: bottom"
              src="${data.images[i + 4]}"
            />
          </a>
        </td>`
      )
      .join("")}
    </tr>`;
    if (data?.footerNav === true) {
      return footerNav;
    }
  };
  const used = Array.from({ length: data.usedRows })
    .map(
      (e, i) => `<tr>
      <td colspan="${colspan}" key="${i}">
        <a
          href="${data.offerLinks[i]}"
          ><img
            src="${data.images[i + 4]}"
            style="display: block; vertical-align: bottom"
            alt=""
        /></a>
      </td>
    </tr>`
    )
    .join("");

  return `<html>
   <head>
     <title>${data?.title}</title>
     <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
   </head>
   <body
     bgcolor="#FFFFFF"
     leftmargin="0"
     topmargin="0"
    marginwidth="0"
    marginheight="0"
  >
    <table
      id="Table_01"
      border="0"
      cellpadding="0"
      cellspacing="0"
      align="center"
      style="border: 3px solid #cccccc; border-spacing: 0; width: 600px"
    >
      <tr id="header">
        <td colspan="${colspan}">
          <a
            href="${data.headerImageURL}"
            ><img
              src="${data.images[0]}"
              style="display: block"
              alt=""
          /></a>
        </td>
      </tr>
      <tr id="navBar">
        ${navBar}
      </tr>
      ${offers}
      ${data?.usedOffers === true ? used : ``}
      ${data?.footerNav === true ? handleFooterNav() : ``}
      <tr>
        <td colspan="${colspan}">
          <a
            href="${footerURL}"
            ><img
              src="${data.images[data.images.length - 1]}"
              style="display: block"
              alt=""
          /></a>
        </td>
      </tr>
    </table>
    <table
      id="Table_02"
      border="0"
      cellpadding="0"
      cellspacing="0"
      width="600"
      align="center"
    >
      <tr>
        <td>
          <p style="white-space: nowrap; text-align: center; font-size: 10px">
            ${data.additionalText}
          </p>
        </td>
      </tr>
    </table>
  </body>
</html>`;
};
